export const environment = {
  production: true,

  checkItApiUrl: 'https://datalive-vehicle-check-staging.nw.r.appspot.com/api', // Staging
  dataliveApiUrl: 'https://datalive-staging.appspot.com/api', // Staging

  ssoAuthUrl: 'https://dashboard.datalive-staging.com/oauth2/',
  authUrl: 'https://auth.datalive-staging.com/',

  webAppUrl: 'https://utilisation.datalive-staging.com',
  dlWebAppUrl: 'https://dashboard.datalive-staging.com',
  siWebAppUrl: 'https://inspection.datalive-staging.com',
  defectWebAppUrl: 'https://defect.datalive-staging.com',
  erWebAppUrl: 'https://er.datalive-staging.com',
  onboardingWebAppUrl: 'https://onboarding.datalive-staging.com',

  
  appReference: 'VEHICLE_UTILISATION',
  developmentAccessToken: null

  
};

